import React from "react";
import { XMarkIcon } from "@heroicons/react/24/outline";
import { useModals } from "../stores/modalStore";

export const ModalContainer: React.FC = () => {
  const { modals, close } = useModals();

  if (modals.length === 0) return null;

  return (
    <div className="fixed inset-0 z-50">
      {modals.map((modal) => (
        <div
          key={modal.id}
          className="fixed inset-0 bg-gray-100/70 flex items-center justify-center p-4"
          onClick={() => modal.closable !== false && close(modal.id)}
        >
          <div
            className={`
              bg-white
            rounded-lg shadow-sm max-h-full overflow-y-auto
              ${modal.size === "sm" && "max-w-sm w-full"}
              ${modal.size === "md" && "max-w-md w-full"}
              ${modal.size === "lg" && "max-w-lg w-full"}
              ${modal.size === "xl" && "max-w-xl w-full"}
              ${!modal.size && "max-w-md w-full"}
            `}
            onClick={(e) => e.stopPropagation()}
          >
            {modal.title && (
              <div className="flex items-center justify-between p-4 border-b border-gray-300">
                <h2 className="text-lg font-semibold text-text-primary">
                  {modal.title}
                </h2>
                {modal.closable !== false && (
                  <button
                    onClick={() => close(modal.id)}
                    className="text-text-muted hover:text-text-primary transition-colors"
                  >
                    <XMarkIcon className="w-5 h-5" />
                  </button>
                )}
              </div>
            )}
            <div className="p-4">{modal.content}</div>
          </div>
        </div>
      ))}
    </div>
  );
};
